import * as React from "react";
import { observer, inject } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { ILocalization, IStartMenu } from "../../../models/localization";
import { ScreenMode } from "../../../models/enums";
import { Row, Col } from "react-flexbox-grid";
import Button from "material-ui/Button";
import FeaturedContent from "../../../models/featuredContent";
import { FeatureLevel, EmptyId } from "../../../models/enums";
import * as s from "./header.css";

@inject("store") @observer
export class Header extends React.Component<{ store: SeekerStore }, {}> {

  constructor(props: any) {
    super(props);
  }

  render(): JSX.Element {
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    const primaryItems: Array<FeaturedContent> = this.props.store.viewState.featuredContent.filter((fc: FeaturedContent): boolean => { return fc.level === FeatureLevel.LandingImage });
    let img: string = "";
    primaryItems.map((fc: FeaturedContent, i: number): void => {
      if (mode === ScreenMode.Mobile) {
        img = `/image/${fc.mobileImageId}`;
      } else {
        img = `/image/${fc.imageId}`;
      }     
    })
    const local: IStartMenu = this.props.store.localization.fields.startMenu;
    const localization: ILocalization = this.props.store.localization.fields;

    /* fallback */
    if (img.length < 1 || img === `/image/${EmptyId}`) {
      if (mode === ScreenMode.Mobile) {
        img = "images/image1mobile.png";
      } else {
        img = "images/image1.png";
      }
    }
    return (<Row>
      <Col xs={12} className={s.imgCol}>
        <div className={s.outerBox}>
          <img src={img} alt="SkillSmart header logo" className={s.opsImgDesktop} />
          <div className={s.overlay}></div>
          <div className={s.onTop}>
            <Row>
              <Col xs={10} sm={9} md={7}>
                {mode === ScreenMode.Mobile && <h2 className={s.header}>{local.header}</h2>}
                {mode !== ScreenMode.Mobile && <h2 className={s.header}>{local.header}</h2>}
              </Col>
            </Row>
            <Row>
              <Col xs={9} sm={8} md={6} lg={5}>
                {mode === ScreenMode.Mobile && <p className={s.subHeader}>{local.subHeader}</p>}
                {mode !== ScreenMode.Mobile && <h6 className={s.subHeader}>{local.subHeader}</h6>}           
              </Col>
            </Row>
            <Row><Col xs={12}>
              <Button raised size="large" color="secondary" key="login" onClick={() => this.props.store.viewState.setShowLogin(true)}>{localization.nav.login}</Button>
              <Button style={{ marginLeft: "16px" }} raised size="large" color="secondary" key="register" onClick={() => this.props.store.viewState.setShowRegister(true)}>{localization.nav.register}</Button>
            </Col></Row>
          </div>
        </div>
      </Col>
    </Row>)
  }
}


// WEBPACK FOOTER //
// ./src/components/start/header/index.tsx